import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getNextPage } from '../../../actions/lister-actions';
import TRANSLATIONS from './translations@default.json';

export const LoadMoreProductsButton = () => {
	const dispatch = useDispatch();
	const mainRef = useRef(null);

	const { pages: { NextPageUrl } = {} } = useSelector((state) => state);

	if (!NextPageUrl) {
		return null;
	}

	const handleNextPage = () => {
		dispatch(
			getNextPage(NextPageUrl, {
				type: '',
				trackHistory: true,
			})
		);
	};

	return (
		<div className="w-full p-2 pb-12">
			<button
				ref={mainRef}
				type="button"
				onClick={() => {
					mainRef.current.blur();
					handleNextPage();
				}}
				className="cta btn btn-primary w-full text-center flex justify-center"
				data-tag-name="load more products button">
				{TRANSLATIONS.loadMoreProductsButton}
			</button>
		</div>
	);
};

export default LoadMoreProductsButton;
